import React from "react";

const BuybuttonIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    version="1.1"
    id="Camada_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 3000 3000"
    {...props}
  >
    <style type="text/css">
      {
        ".st0buybutton{fill:#080413;}.st1buybutton{fill:#FFFFFF;}.st2buybutton{fill:#41A800;}.st3{fill:#9DF70B;}"
      }
    </style>
    <g>
      <path
        className="st0buybutton"
        d="M2657.1,2691.3c-1.8-56.3-8.7-112-20.8-167c-23.7-107-64.3-207.4-118-302.6C2466,2129,2400.5,2046,2331,1966
		c-38.6-44.4-79.3-86.4-121.6-127.3l-9.1-8.2c3.6-1.6,7.2-3.2,10.7-4.8c29.4-13,59.3-25,88-39.6c57.4-29.3,108.6-66.6,150-116.4
		c29-34.9,54.8-72.2,79.5-110.3c8.6-13.2,15.4-27.5,21.1-42.3c5.7-14.9,6.8-29.9,3.6-45.5c-1.5-7.4-3.5-14.7-5.9-21.9
		c-8.3-25.4-21.5-48.6-33.9-72.1c-41.2-78.1-94.6-146.6-160.7-205.3c-72.9-64.8-152.8-120.1-234.2-173.5
		c-15.7-10.3-32.7-16.8-50.9-20.3c-16.4-3.2-33-5.3-49.9-5.3c-453.5,0.1-907.1,0.1-1360.6,0.1c-101.9,0-203.8,0-305.6,0.1
		c-4.1,0-8.2-0.4-12.7,0.9c1.2,3.4,2.1,6.2,3.2,8.9c19,46.9,37.7,93.8,57,140.6c29.9,72.8,78.6,129.9,145.3,171.5
		c32.2,20.1,66.5,35.8,102.7,47.1c78.6,24.6,159.4,38.9,241.2,47.3c64.5,6.6,129.2,8.1,194,5.8c43.7-1.6,87.3-4.3,130.9-6.5
		c8.5-0.4,17.1-0.8,25.6-1.3c2.9-0.2,5.3,0.2,5.4,3.9l0,1448.9h1416.4C2660,2809.5,2658.2,2727.6,2657.1,2691.3z M2115.2,1369.6
		c-8.6,7.1-16.8,14.7-25.3,21.9c-31.9,27.5-69.2,36.2-110.2,31.5c-56-6.4-100.3-32.7-132.8-78.9c-18.3-26-26.6-55.3-29.7-86.5
		c-0.7-7.2-1.4-14.4-2.4-21.5c-0.4-3.4,0.7-5.3,3.7-7.1c34.4-21.1,71.2-34.7,111.5-38.5c10.5-1,20.9-2.1,30.9-2.1
		c43.5-1.3,77.5,15.6,103.1,50c20.8,27.8,38.6,57.1,47.4,91.1c2.6,10.2,4.6,20.5,7.1,30.7C2119.4,1364.3,2118.4,1367,2115.2,1369.6z
		"
      />
      <path
        className="st0buybutton"
        d="M1105.5,659.4c34.7,49.1,75.6,92.6,119.1,133.8c33.6,31.9,67.2,63.8,100.5,96c4.9,4.7,9.8,6.6,16.5,6.6
		c111.1,0.5,222.2,1.1,333.2,1.7c114.4,0.6,228.7,1.2,343.1,1.8c5.7,0,11.4,0,17.2,0c0.2-0.7,0.4-1.5,0.6-2.2
		c-305.6-245.8-611.2-491.6-916.8-737.4c-3,3.5-4.2,7-5.7,10.3c-15.9,35-31.9,69.9-47.8,104.9c-6,13.2-11.2,26.6-15.9,40.3
		c-24.6,73-28.6,146.6-6.8,221C1055.9,581.2,1078.6,621.4,1105.5,659.4z"
      />
      <path
        className="st0buybutton"
        d="M956.2,2395.6c-125.2,0.1-220.8,98.3-222.8,222.6c2.2,124.3,97.6,222.4,223,222.4
		c124.9-0.1,222.4-97.6,222.4-222.6C1178.7,2492.5,1080.5,2395.5,956.2,2395.6z"
      />
      <path
        className="st1buybutton"
        d="M2111.4,1329.5c-8.8-34-26.6-63.2-47.4-91.1c-25.7-34.4-59.6-51.3-103.1-50c-10,0-20.4,1.1-30.9,2.1
		c-40.3,3.8-77.2,17.4-111.5,38.5c-3,1.8-4.1,3.7-3.7,7.1c0.9,7.2,1.6,14.3,2.4,21.5c3.1,31.2,11.5,60.5,29.7,86.5
		c32.5,46.2,76.7,72.5,132.8,78.9c41,4.7,78.3-4,110.2-31.5c8.5-7.3,16.7-14.8,25.3-21.9c3.2-2.7,4.3-5.4,3.3-9.4
		C2116,1350,2114,1339.7,2111.4,1329.5z"
      />
    </g>
    <g>
      <path
        className="st2buybutton"
        d="M1610.7,2140.6l74.6-177.6c52.7-125.5,98.2-253.8,136.3-384.5l29.7-101.9c11.3-31.2,1.8-61.8-18.2-81.9
		l-462.6,462.6c9.1,9.1,16,20.5,19.7,33.3l72,245.3C1483.5,2208.4,1585,2211.6,1610.7,2140.6z"
      />
      <path
        className="st3"
        d="M1751.3,1376.6l-56.7,15.7c-159.5,44-315.8,99.1-467.8,164.7l-139.5,60.3c-71,25.7-67.8,127.2,4.6,148.4
		l245.3,72c12.8,3.7,24.1,10.6,33.3,19.7l462.6-462.6C1813.1,1374.7,1782.5,1365.3,1751.3,1376.6z"
      />
    </g>
  </svg>
);

export default BuybuttonIcon;
